/* フェードイン */
function fadeAnime(){
   $('.fadeUpTrigger').each(function(){
     var elemPos = $(this).offset().top+200;
     var scroll = $(window).scrollTop();
     var windowHeight = $(window).height();
     if (scroll >= elemPos - windowHeight){
     $(this).addClass('fadeUp');//
     }
     });
     $('.fadeUpTrigger02').each(function(){
     var elemPos = $(this).offset().top+200;
     var scroll = $(window).scrollTop();
     var windowHeight = $(window).height();
     if (scroll >= elemPos - windowHeight){
     $(this).addClass('fadeUp02');//
     }
     });
     $('.slideinTrigger').each(function(){
     var elemPos = $(this).offset().top+200;
     var scroll = $(window).scrollTop();
     var windowHeight = $(window).height();
     if (scroll >= elemPos - windowHeight){
     $(this).addClass('slidein');//
     }
     });
 }
   $(window).scroll(function (){
     fadeAnime();
   });
/* 内部リンク上部余白 */
 $(function () {
  var headerHight = 200; //ヘッダーの高さ
  $('a[href^="#"]').click(function () {
  var href = $(this).attr("href");
  var target = $(href == "#" || href == "" ? "html" : href);
  var position = target.offset().top - headerHight;
  $("html, body").animate({
  scrollTop: position
  }, 500, "swing");
  return false;
  });
});
//初回のみモーダルをすぐ出す判定。flagがモーダル表示のstart_open後に代入される
	var access = $.cookie('access')
	if(!access){
		flag = false;
		$.cookie('access', false);
	}else{
		flag = false	
	}
	//モーダル表示
	$(".video-open").modaal({
	start_open:flag, // ページロード時に表示するか
	overlay_close:true,//モーダル背景クリック時に閉じるか
	type: 'video',
	background: '#222', // 背景色
	overlay_opacity:0.8, // 透過具合
	before_open:function(){// モーダルが開く前に行う動作
		$('html').css('overflow-y','hidden');/*縦スクロールバーを出さない*/
	},
	after_close:function(){// モーダルが閉じた後に行う動作
		$('html').css('overflow-y','scroll');/*縦スクロールバーを出す*/
	}
	});
//スクロールしたら表示されるfixed-button
function PageTopCheck(){
  var winScrollTop = $(this).scrollTop();
  var secondTop =  $("#top-title").offset().top - 0; //titleの上から0pxの位置まで来たら
  if(winScrollTop >= secondTop){
    $('.fixed-button').addClass('scroll-view');//.fixed-buttonからscroll-viewというクラス名を付与
 } else {//元に戻ったら
    $('.fixed-button').removeClass('scroll-view');//.fixed-buttonからscroll-viewというクラス名を除去
 }
}
// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  PageTopCheck();/* スクロールした際の動きの関数を呼ぶ*/
});
// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
 PageTopCheck();/* スクロールした際の動きの関数を呼ぶ*/
});